import React__default, { useMemo } from 'react';

const useIsVirtualized = function (children) {
  let isVirtualizationDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return useMemo(() => !isVirtualizationDisabled && React__default.Children.count(children) >= 25, [children, isVirtualizationDisabled]);
};

export { useIsVirtualized as default };
